import {CATEGORY_OPTIONS, docSection, docSectionHead, docSectionTitle, skl} from './constants'
import {ThinkingState} from './ThinkingState'

export function CategoryPreview({categories}: {categories: string[]}) {
  const groups = CATEGORY_OPTIONS.filter((g) => g.categories.some((c) => categories.includes(c.value)))
  return (
    <div style={{padding: '8px 0'}}>
      <ThinkingState />
      {groups.map((g, i) => {
        const selectedItems = g.categories.filter((c) => categories.includes(c.value))
        return (
          <div
            key={g.section}
            className={`${docSection} animate-epg-reveal-up`}
            style={{animationDelay: `${i * 40}ms`}}
          >
            <div className={docSectionHead}>
              <div style={{display: 'flex', alignItems: 'center', gap: 10}}>
                <div style={{width: 18, height: 18, borderRadius: 4, background: 'rgba(180,255,68,0.2)'}} />
                <div className={docSectionTitle}>{g.sectionLabel}</div>
              </div>
              <div style={{fontSize: 11, color: 'rgba(0,0,0,0.35)'}}>
                {selectedItems.length} {selectedItems.length === 1 ? 'item' : 'items'}
              </div>
            </div>
            <div style={{marginTop: 8, display: 'flex', flexDirection: 'column', gap: 5}}>
              <div className={skl} style={{width: '90%', height: 10}} />
              <div className={skl} style={{width: '70%', height: 10}} />
            </div>
          </div>
        )
      })}
    </div>
  )
}
